export const COLOR_SLIDER_TRACK_THICKNESS = 15;
export const COLOR_SLIDER_THUMB_SIZE = 19;

export const COLOR_AREA_SIZE = 192;
export const COLOR_AREA_FOCUSED_THUMB_SIZE = 28;
export const COLOR_AREA_THUMB_SIZE = 19;
export const COLOR_AREA_BORDER_RADIUS = 5;

export const COLOR_PICKER_DEFAULT_COLOR = "#46769A";
